import { render, staticRenderFns } from "./CaseTypeForm.vue?vue&type=template&id=2ffcc953&"
import script from "./CaseTypeForm.vue?vue&type=script&lang=js&"
export * from "./CaseTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports